import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Footer from '../Footer/Footer';
import Navbar from '../Navbar/Navbar';
import CustomizedSteppers from './CustomizedSteppers/CustomizedSteppers';
import DeliveryInfo from './DeliveryInfo/DeliveryInfo';
import { getWindowDimensions } from '../../driver';
import { useTrackOrderDataQuery } from '../../features/api/apiSlice';

const TrackOrderPage = () => {
    const { trackId, orderId } = useParams();
    const [trackData, setTrackData] = useState({});
    const { data: trackOrderData } = useTrackOrderDataQuery({ trackId, orderId });

    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [])
    useEffect(() => {
        setTrackData(trackOrderData);
    }, [trackOrderData])
    return (
        <>
            <Navbar />
            <CustomizedSteppers />
            <DeliveryInfo windowDimensions={windowDimensions} trackData={trackData} />
            <Footer />
        </>
    );
};

export default TrackOrderPage;